<template>
  <div class="zl-multiple-table">
    <div class="zl-multiple-table-header" :style="`width: ${headerWidth}px`">
      <div class="zl-multiple-table-column">
        <el-checkbox v-if="!disabled && type === 'selection'" style="margin-right: 15px;" :value="checked" @change="choose" />
        <table-header :column="column" :data="data">
          <template slot="link" slot-scope="{ row, index, value, item }">
            <el-link type="primary" @click="onLink({ row, index, value })">
              {{ item.format ? item.format({ index, value: row[item.prop], row }) : row[item.prop] === undefined ? '' : row[item.prop] }}
            </el-link>
          </template>
        </table-header>
      </div>
      <div class="zl-multiple-table-end">
        <span class="zl-multiple-total" style="margin-right: 5px;">
          {{ $t('table.totalPre') }}
          <span class="zl-multiple-table-green">{{ allList.length }}</span>
          {{ $t('table.totalFix') }}
        </span>
        <span v-if="!collapse" class="zl-multiple-table-collapse zl-multiple-table-green" @click="collapse = true">{{ $t('table.collapse') }}</span>
        <span v-else-if="allList.length > 5" class="zl-multiple-table-collapse zl-multiple-table-green" @click="collapse = false">{{ $t('table.uncollapse') }}</span>
        <table-operation v-if="_operation" :_operation="_operation" :index="tIndex" :row="data" />
      </div>
    </div>
    <stripe-table
      ref="table"
      :[tableName]="childTable"
      :list="list"
      :custom-column="customColumn"
      :hide-head="hideHead"
      @on-link="onLink"
    />
  </div>
</template>

<script>
import StripeTable from '../stripe-table/stripe-table'
import TableHeader from '@/components/table/table-header/table-header'
import TableOperation from './table-operation'
export default {
  components: {
    TableHeader,
    StripeTable,
    TableOperation
  },
  props: {
    type: {
      type: String,
      default: 'selection'
    },
    hideHead: {
      type: Boolean,
      default: true
    },
    listProp: {
      type: String,
      default: 'sumList'
    },
    tIndex: {
      type: Number,
      default: -1
    },
    data: {
      type: Object,
      default: () => ({})
    },
    column: {
      type: Array,
      default: () => []
    },
    childTable: {
      type: Object,
      default: () => ({})
    },
    selection: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    customColumn: {
      type: Array,
      default: () => []
    },
    hideTableList: {
      type: Boolean,
      default: true
    },
    // eslint-disable-next-line
    _operation: {}
  },
  data() {
    return {
      collapse: true
    }
  },
  computed: {
    tableName() {
      return '$table'
    },
    allList() {
      return this.data[this.listProp] || []
    },
    list() {
      return this.collapse ? this.allList.slice(0, 5) : this.allList
    },
    checked() {
      return this.selection.includes(this.data)
    },
    operation() {
      return [...(this._operation.operation || [])]
    },
    headerWidth() {
      return this.$store.getters.appWidth - 24
    }
  },
  watch: {
    hideTableList: {
      handler(val) {
        this.collapse = val
      },
      immediate: true
    }
  },
  methods: {
    validate(callback) {
      this.$refs.table.validate(callback)
    },
    validateCell(index, props, callback) {
      this.$refs.table.validateCell(index, props, callback)
    },
    choose(val) {
      this.$emit('choose-item', val, this.data)
    },
    onLink(val) {
      this.childTable._list && this.childTable._list.vm && this.childTable._list.vm.onLink(val)
    }
  }
}
</script>

<style lang="scss" scoped>
.zl-multiple-table {
  background: #fff;
  padding-bottom: 8px;
  &-header {
    box-sizing: border-box;
    padding: 8px 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: max-content;
    // width: max-content;
    // min-width: 100%;
  }
  &-column {
    display: flex;
    align-items: center;
  }

  &-end {
    display: flex;
    align-items: center;
  }
  &-green {
    color: #92D051;
  }
  &-collapse {
    cursor: pointer;
  }
}
</style>
